import { useQuery } from '@tanstack/react-query';

import { workflowDefinitionMetricKeys } from '@/domains/workflow-definitions';

export const useWorkflowDefinitionsVariantsMetricQuery = () => {
  const { data, isLoading } = useQuery({
    ...workflowDefinitionMetricKeys.workflowDefinitionVariantMetrics(),
    //@ts-ignore
    enabled: true,
  });

  return {
    data,
    isLoading,
  };
};
